// Reference-font budgets in CSS px, checked with production Inter by tools/lab/check-lengths.mjs.
// Browser text scaling is allowed; the fact column remains proportional, not a fixed pixel width.
// Status budgets are measured from the rendered grid column, including dot and gap.
export const pointStatusBudget = element => element.getBoundingClientRect().width;
export const DETAIL_LABEL_MAX_PX = 90;
export const DETAIL_LABEL_SHARE = .4;
export const POINT_SHORT_KEYS = Object.freeze({free: 'stateFreeShort', busy: 'stateBusyShort', out: 'stateOutShort', unknown: 'stateUnknownShort'});
export const DETAIL_LABEL_KEYS = Object.freeze(['detailOpening', 'detailPrice', 'detailSource', 'detailUpdated', 'detailSiteId']);
